module.exports = __webpack_public_path__ + "static/media/24(1).c5262257.jpg";